import * as React from "react";
import './Disclaimer.css'
import {ConfiguratorModel} from "../../Controller/3DController/ConfiguratorModel";
import {nameMap} from "../../Controller/3DController/ModelLoad/ModelLoadController";
import { getWhiteLabel } from "../../whitelabel";
import { translate } from "../../Controller/3DController/translateController";
import { getUrlData } from "../../urlData";

interface Props{
    close:()=>void,
    preload:boolean,
    configuratorModel:ConfiguratorModel
}

interface State{
    disclaimer:string
}

export class Disclaimer extends React.Component<Props,State> {
    private disclaimer;

    constructor(props:Props){
        super(props);

        let disclaimer;

        const model = getUrlData().config ? getUrlData().config.model : undefined;

        let car = nameMap.find(e => e.car === model);
        if(car){
            disclaimer = car;
        }

        if (props.configuratorModel) {
            let model = this.props.configuratorModel.modelLoadController.getModel();
            if (model) {
                disclaimer = model;
            }
        }

        this.state = {
            disclaimer: disclaimer ? disclaimer.disclaimer : undefined
        }
    }

    render(){
        return(
            <div className={this.props.preload?"disclaimer-holder-background":""}>
                <div className={"disclaimer-holder" + (this.props.preload?" disclaimer-holder-preload":"")}>
                    <div className={"disclaimer-background"}>
                        <div className={"disclaimer-header"}>
                            <span>{getWhiteLabel().name.toUpperCase()}</span>
                        </div>

                        {this.disclaimer ? (
                            <span>
                                {this.disclaimer}
                            </span>
                        ) : (
                            <span>
                                {translate("id_disclaimer_main_1")}<br/><br/>
                                {translate("id_disclaimer_main_2")}<br/><br/>
                                {(this.state.disclaimer && <div dangerouslySetInnerHTML={{__html: this.state.disclaimer}}/>)}
                            </span>
                        )}

                        <div className={"disclaimer-button-background"}>
                            <div className={"disclaimer-button"} onClick={()=>{
                                this.props.close();
                                document.cookie = "disclaimer=true";
                            }}>
                                <div className={"ripple"}></div>
                                <img src={`./${HASH}/Icons_Png/Tick.svg`}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}